if (!customElements.get('home-inspirations')) {
  class HomeInspirations extends HTMLElement {
    constructor() {
      super();
      this._swiperContainer = null;
      this._swiperInstance = null;
      this._dialogSwiperContainer = null;
      this._dialogSwiper = null;
      this._closeDialogButton = null;
    }

    connectedCallback() {
      requestAnimationFrame(() => {
        this._swiperContainer = this.querySelector('.home-inspirations__container .swiper');
        this._dialogSwiperContainer = this.querySelector('.home-inspirations__dialog-wrapepr .swiper');
        this._dialogWrapper = this.querySelector('.home-inspirations__dialog-wrapepr');
        this._closeDialogButton = this.querySelector('.home-inspirations__dialog-close');
        this.initializeSwiper();
        this.initEvent();
      });
    }

    initEvent() {
      this._closeDialogButton.addEventListener('click', () => {
        this._dialogWrapper.classList.toggle('active');
      });
    }

    initializeSwiper() {
      if (!this._swiperContainer) {
        console.error('Swiper container not found');
        return;
      }

      this._swiperInstance = new Swiper(this._swiperContainer, {
        loop: true,
        slidesPerGroup: 1,
        slidesPerView: 1,
        spaceBetween: 16,
        observer: true,
        resizeObserver: true,
        navigation: {
          nextEl: this._swiperContainer.querySelector('.swiper-btn--next'),
          prevEl: this._swiperContainer.querySelector('.swiper-btn--prev'),
        },
        breakpoints: {
          590: {
            loop: true,
            slidesPerGroup: 1,
            slidesPerView: 1,
            spaceBetween: 16,
          },
          769: {
            loop: false,
            slidesPerGroup: 2,
            slidesPerView: 2,
            spaceBetween: 24,
          },
          990: {
            loop: false,
            slidesPerGroup: 3,
            slidesPerView: 3,
            spaceBetween: 24,
          },
          1280: {
            loop: false,
            slidesPerGroup: 4,
            slidesPerView: 4,
            spaceBetween: 24,
          },
        }
      });

      this._dialogSwiper = new Swiper(this._dialogSwiperContainer, {
        slidesPerGroup: 1,
        slidesPerView: 1,
        spaceBetween: 16,
        navigation: {
          nextEl: this._dialogWrapper.querySelector('.swiper-btn--next'),
          prevEl: this._dialogWrapper.querySelector('.swiper-btn--prev'),
        },
        breakpoints: {
        }
      });
    }

    openDialog(index) {
      if (index != undefined) {
        this._dialogSwiper.slideTo(index, 0);
      }
      this._dialogWrapper.classList.add('active');
    }

    closeDialog() {
      this._dialogWrapper.classList.remove('active');
    }
  }

  customElements.define('home-inspirations', HomeInspirations);
}

if (!customElements.get("home-inspirations-trigger")) {
  class HomeInspirationsTrigger extends HTMLElement {
    constructor() {
      super();
      this.index = Number(this.getAttribute('data-index'));
      this.initEvents();
    }

    initEvents() {
      this.addEventListener('click', function (e) {
        const section = this.closest('home-inspirations');
        if (section) section.openDialog(this.index);
      });
    }

    connectedCallback() { }
  }

  customElements.define("home-inspirations-trigger", HomeInspirationsTrigger);
}
